
import { useState } from 'react';
import { floors } from '../data/floorData';
import { Load } from '../types';

export const useFloorSelection = (loads: Load[]) => {
  const [selectedFloor, setSelectedFloor] = useState<number>(1);
  const [selectedZone, setSelectedZone] = useState<string | null>(null);

  const getFloorLoads = () => {
    if (!selectedFloor) return loads;
    const floorLoadIds = floors.find(f => f.id === selectedFloor)?.loads || [];
    return loads.filter(load => floorLoadIds.includes(load.id));
  };

  return {
    selectedFloor,
    setSelectedFloor,
    selectedZone,
    setSelectedZone,
    getFloorLoads,
  };
};
